module.exports = __webpack_public_path__ + "img/success.a412f39d.png";